/**
 * Whale-mode dashboard fillers when REACT_APP_DEMO_MODE=true (mirrors backend DEMO_MODE for demos).
 * Merged only when not already using debug/demo portfolio data.
 */

const GHOST_PREFIX = "ghost_demo_";

function daysAgo(n) {
  const d = new Date();
  d.setDate(d.getDate() - n);
  d.setHours(12, 0, 0, 0);
  return d;
}

/**
 * @param {string} [ownerId]
 * @returns {object[]}
 */
export function buildGhostRepairs(ownerId) {
  const oid = ownerId || "demo";
  const now = new Date();
  return [
    {
      id: `${GHOST_PREFIX}r1`,
      ownerId: oid,
      title: "HVAC seasonal tune-up",
      status: "pending",
      priority: "medium",
      category: "hvac",
      completed: false,
      completedDate: null,
    },
    {
      id: `${GHOST_PREFIX}r2`,
      ownerId: oid,
      title: "Turnover deep clean",
      status: "scheduled",
      priority: "medium",
      category: "cleaning_turnover",
      completed: false,
      scheduledDate: now,
    },
    {
      id: `${GHOST_PREFIX}r3`,
      ownerId: oid,
      title: "Water heater pilot assessment",
      status: "in_progress",
      priority: "high",
      category: "plumbing",
      completed: false,
    },
    {
      id: `${GHOST_PREFIX}r4`,
      ownerId: oid,
      title: "Exterior paint touch-up",
      status: "open",
      priority: "low",
      category: "painting",
      completed: false,
    },
    {
      id: `${GHOST_PREFIX}r5`,
      ownerId: oid,
      title: "Common area tuckpointing",
      status: "pending",
      priority: "medium",
      category: "tuckpointing_masonry",
      completed: false,
    },
    {
      id: `${GHOST_PREFIX}r6`,
      ownerId: oid,
      title: "Dishwasher drain line",
      status: "assigned",
      priority: "high",
      category: "appliances",
      completed: false,
    },
    {
      id: `${GHOST_PREFIX}r7`,
      ownerId: oid,
      title: "Parking lot lighting",
      status: "completed",
      priority: "medium",
      category: "electrical",
      completed: true,
      completedDate: daysAgo(12),
    },
    {
      id: `${GHOST_PREFIX}r8`,
      ownerId: oid,
      title: "Snow removal contract renewal",
      status: "completed",
      priority: "low",
      category: "snow_removal",
      completed: true,
      completedDate: daysAgo(45),
    },
    {
      id: `${GHOST_PREFIX}r9`,
      ownerId: oid,
      title: "Landscape refresh",
      status: "scheduled",
      priority: "low",
      category: "landscaping",
      completed: false,
      scheduledDate: new Date(now.getTime() + 3 * 86400000),
    },
  ];
}

/**
 * Synthetic current-month rent rows for Property Overview cards.
 * @param {string} ownerId
 * @param {number} doorCount
 */
export function buildGhostRentPayments(ownerId, doorCount = 24) {
  const n = Math.min(Math.max(doorCount, 12), 50);
  const base = 1285;
  const rows = [];
  const now = new Date();
  const due = new Date(now.getFullYear(), now.getMonth(), 5, 12, 0, 0, 0);

  for (let i = 0; i < n; i++) {
    const amt = base + (i % 7) * 35;
    const overdue = i % 17 === 0;
    const paid = !overdue && i % 11 !== 0;
    rows.push({
      id: `${GHOST_PREFIX}pay_${i}`,
      ownerId,
      tenantId: `${GHOST_PREFIX}t_${i}`,
      unitId: `${GHOST_PREFIX}u_${i}`,
      amount: amt,
      dueDate: due,
      status: paid ? "paid" : overdue ? "overdue" : "pending",
      tenantName: `Demo Tenant ${i + 1}`,
      unitName: `Unit ${String.fromCharCode(65 + (i % 26))}-${100 + i}`,
    });
  }
  return rows;
}
